<template>
  <nav class="navigation">
    <div class="nav-container">
      <div class="nav-logo">
        <img src="@/assets/image/huashi_logo.png" alt="华视集团" class="logo-image" />
      </div>
      <ul class="nav-menu">
        <li class="nav-item">
          <router-link to="/" class="nav-link" :class="{ active: $route.path === '/' }">
            首页
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/products" class="nav-link" :class="{ active: $route.path === '/products' }">
            产品服务
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/solutions" class="nav-link" :class="{ active: $route.path === '/solutions' }">
            解决方案
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/news" class="nav-link" :class="{ active: $route.path === '/news' }">
            新闻动态
          </router-link>
        </li>
        <li class="nav-item dropdown" @mouseenter="showDropdown = true" @mouseleave="showDropdown = false">
          <router-link to="/about" class="nav-link" :class="{ active: $route.path === '/about' }">
            关于华视
            <span class="dropdown-arrow" :class="{ rotated: showDropdown }">▼</span>
          </router-link>
          <ul class="dropdown-menu" v-show="showDropdown">
            <li class="dropdown-item">
              <router-link to="/about" class="dropdown-link">华视数科</router-link>
            </li>
            <li class="dropdown-item">
              <a href="https://www.youmeimu.com/" target="_blank" class="dropdown-link">华视集团</a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'Navigation',
  data() {
    return {
      showDropdown: false
    }
  }
}
</script>

<style scoped>
.navigation {
  background-color: #93BEEB;
  padding: 0;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.nav-container {
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 40px;
  height: 60px;
}

.logo-image {
  height: 40px;
  width: auto;
  object-fit: contain;
}

.nav-menu {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 30px;
}

.nav-item {
  position: relative;
}

.nav-link {
  text-decoration: none;
  color: #333;
  font-size: 16px;
  font-weight: 500;
  padding: 10px 0;
  transition: color 0.3s ease;
  display: flex;
  align-items: center;
  gap: 5px;
}

.nav-link:hover {
  color: #0066cc;
}

.nav-link.active {
  color: #0066cc;
  border-bottom: 2px solid #0066cc;
}

.dropdown-arrow {
  font-size: 12px;
  transition: transform 0.3s ease;
}

.dropdown-arrow.rotated {
  transform: rotate(180deg);
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  background-color: white;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  list-style: none;
  margin: 0;
  z-index: 1000;
  padding: 5px;
}

.dropdown-item {
  margin: 0;
}

.dropdown-link {
  display: block;
  padding: 8px 16px;
  color: #333;
  text-decoration: none;
  font-size: 14px;
  transition: background-color 0.2s ease;
  white-space: nowrap;
}

.dropdown-link:hover {
  background-color: #f5f5f5;
  color: #0066cc;
}

.dropdown-link.router-link-active {
  color: #000;
  background: rgba(153, 153, 153, 0.2);
  border-radius: 5px;
}

@media (max-width: 768px) {
  .nav-container {
    flex-direction: column;
    height: auto;
    padding: 10px 20px;
  }
  
  .nav-menu {
    flex-direction: column;
    gap: 10px;
    width: 100%;
    text-align: center;
  }
  
  .nav-item {
    width: 100%;
  }
  
  .dropdown-menu {
    position: static;
    box-shadow: none;
    border: none;
    background-color: #f8f9fa;
    margin-top: 5px;
  }
  
  .dropdown-link {
    padding: 10px 16px;
    font-size: 16px;
  }
}
</style>
